module.exports = __webpack_public_path__ + "img/text-mark10.b76d5aee.png";